<template>
    <div>
        <CRow class="d-flex justify-content-end">
            <a href="https://appcenter.ms" target="_blank">{{$t("detailedStats")}}</a>
        </CRow>
        <CRow class="mb-1">
            <CChartLine id="access-chart" :datasets="accesses" labels="days" :options="{ maintainAspectRatio: false }"/>
        </CRow>
        <CRow class="mt-1">
            <CCol sm="6">
                <label class="">{{ $t('topPois') }}</label>
                <p v-if="topPois.length == 0">{{ $t('noData') }}</p>
                <table v-else class="table table-striped">
                    <tbody>
                        <tr v-for="(poi, index) in topPois" :key="poi.poiName">
                            <th scope="row">{{index + 1}}.</th>
                            <td>{{poi.name}}</td>
                            <td>({{poi.visits}} {{$t("visit")}})</td>
                        </tr>
                    </tbody>
                </table>
            </CCol>
        </CRow>
    </div>
</template>

<script>
import { CChartLine } from '@coreui/vue-chartjs'
import { mapState, mapActions } from 'vuex'

export default {
    components: { CChartLine },
    computed: {
        ...mapState('stats', ['statsOutput']),
        ...mapState('account', ['user']),
        company: function()
        {
            return this.user && this.user.userInfo && this.user.userInfo.companyInfo ? this.user.userInfo.companyInfo : null;
        },
        accesses: function()
        {
            var result = [];

            if(this.statsOutput && this.statsOutput.data && this.statsOutput.data.accesses )
            {
                result = [
                    {
                        label: this.$i18n.t("usage90days"),
                        backgroundColor: '#321fdb',
                        data:  this.statsOutput.data.accesses 
                    }
                ];
            }

            return result;
        },
        // topCompanies: function()
        // {
        //     var result = [];

        //     if(this.statsOutput && this.statsOutput.object && this.statsOutput.object.companies )
        //     {
        //         result = this.statsOutput.object.companies;
        //     }

        //     return result;
        // },
        topPois: function()
        {
            var result = [];

            if(this.statsOutput && this.statsOutput.data && this.statsOutput.data.pois )
            {
                result = this.statsOutput.data.pois;
            }

            return result;
        },

    },
    methods:
    {
        ...mapActions('stats', ['getStats']),
    },
    mounted: function(){
        this.getStats(this.$i18n.locale); // Get stats
    }
}
</script>

<style>

#access-chart
{
    height: 40vh;
    width: 100%;
}

</style>